import { LoaderService } from './../loader/loader.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TimeGraph } from '../graphs/timegraph';
import { Test } from '../test-history/test';
@Injectable({
	providedIn: 'root',
})
export class TestService {
	private _testHistory$: Subject<Test[]>;
	private _studentTimeGraph$: Subject<any>;

	constructor(
		private httpClient: HttpClient,
		public LoaderService: LoaderService,
	) {
		this._testHistory$ = new Subject();
		this._studentTimeGraph$ = new Subject();
	}

	public getPhonicsTestHistory(
		participantId,
		assessmentBookId,
		assessmentTemplateId,
	): Observable<any> {
		this.LoaderService.setLoadingTestHistory(true);
		return this.httpClient.get<any>(
			`${environment.apiUrl}/main/getPhonicsTestHistory/participantId/${participantId}/assessmentBookId/${assessmentBookId}/assessmentTemplateId/${assessmentTemplateId}`,
		);
	}

	public setTestHistory(testHistory: Test[]) {
		this.LoaderService.setLoadingTestHistory(false);
		this._testHistory$.next(testHistory);
	}

	get testHistory() {
		return this._testHistory$.asObservable();
	}

	allTestHistory(participantId): Observable<any[]> {
		return this.httpClient.get<any[]>(
			`${environment.apiUrl}/main/allHistory/participantId/${participantId}`,
		);
	}

	public submitPhonicsScore(scores) {
		console.log('postTestScores');
		return this.httpClient.post<any>(
			`${environment.apiUrl}/main/submitPhonicsScore/`,
			scores,
		);
	}

	public getPhonicsTestQuestions(
		participantId,
		assessmentBookId,
		assessmentTemplateId,
	) {
		return this.httpClient.get<any>(
			`${environment.apiUrl}/main/getPhonicsTestQuestions/participantId/${participantId}/assessmentBookId/${assessmentBookId}/assessmentTemplateId/${assessmentTemplateId}`,
		);
	}
	public getPhonicsStartEndDates(nodeId) {
		return this.httpClient.get<any>(
			`${environment.apiUrl}/main/getPhonicsStartEndDates/nodeId/${nodeId}`,
		);
	}

	public getStudentTimeGraph(
		participantId,
		nodeId,
		assessmentBookId,
		assessmentTemplateId,
	) {
		this.LoaderService.setLoadingStudentTimeGraph(true);
		return this.httpClient.get<any>(
			`${environment.apiUrl}/main/getStudentTimeGraph/participantId/${participantId}/nodeId/${nodeId}/assessmentBookId/${assessmentBookId}/assessmentTemplateId/${assessmentTemplateId}`,
		);
	}

	public setStudentTimeGraphData(timeGraph: TimeGraph) {
		this.LoaderService.setLoadingStudentTimeGraph(false);
		this._studentTimeGraph$.next(timeGraph);
	}

	public deletePhonicsScore(scoreIdObject) {
		return this.httpClient.post<any>(
			`${environment.apiUrl}/main/deletePhonicsScore/`,
			scoreIdObject,
		);
	}

	get timeGraph() {
		return this._studentTimeGraph$.asObservable();
	}
}
